import React from 'react'
import styles from './EnquiryCourses.module.css'

const EnquiryCourses = () => {
    return (
        <div>EnquiryCourses</div>
    )
}

export default EnquiryCourses